import React from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormAutocomplete from "./FormAutocomplete";

function FormAutocompleteTC(props) {
  return (
    <FormFieldTwoColumns {...props}>
      <FormAutocomplete name={props.name} />
    </FormFieldTwoColumns>
  );
}

FormAutocompleteTC.defaultProps = {
  nullable: false,
  freeSolo: false,
  multiple: false,
  options: [],
};

FormAutocompleteTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  tKey: PropTypes.string, // FormField props
  tDefault: PropTypes.string, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  options: PropTypes.array,
  freeSolo: PropTypes.bool,
  multiple: PropTypes.bool,
};

export default FormAutocompleteTC;
